import React from 'react'
import { useHistory } from 'react-router-dom'

const ListFilters = () => {
  const history = useHistory()
  const redirectToAddNew = () =>
    history.push({
      state: { reportingCategoryUuid: 'new' },
    })

  return (
    <div className="reporting-categories-filters">
      <button
        className="btn new-item"
        type="button"
        onClick={redirectToAddNew}
      >
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default ListFilters
